// @ts-strict-ignore
import { useRecommendedActions } from 'hooks/useRecommendedActions';
import { useSelector } from 'react-redux';

import { Box } from 'components/Box';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { TileCarousel } from 'components/TileCarousel';
import { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/CmsApiRecommendedActions';
import { MainStoreState } from 'modules/main/store';
import { listingSearchHomePath } from 'utils/searchHomePages';

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsRecommendedActionsBlock({ data: { headline } }: Props) {
  const searchLocation = useSelector<MainStoreState>(
    (state) => state.mainSearch.searchLocation
  ) as SearchLocation;

  const { data: recommendedActions, isLoading } =
    useRecommendedActions(searchLocation);

  if (isLoading) return <LoadingIndicator />;

  return (
    <Box data-qa-id="recommended-actions">
      <TileCarousel
        headline={headline}
        results={recommendedActions}
        seeAllText={
          /* TRANSLATORS: Link to actions search */
          getText('See All Volunteer Opportunities')
        }
        seeAllUrl={`${listingSearchHomePath('VOLOP')}`}
        listingType="ACTION"
      />
    </Box>
  );
}
